import React from "react";
import "./Technical.css";
import Common_Title from "../../common_components/common_title/Common_Title";

const Technical = () => {
  return (
    <>
      <section className="technical_section">
        <div className="container">
          <Common_Title simpleText="Technical" darkText="Expertise " />
          <p className="para">
            Experience the power of{" "}
            <b>
              your own fully customised EdTech platform — built to maximise
              results and simplify your business.
            </b>
            Search, compare, and apply effortlessly. Explore eligible courses
            and scholarships, track commissions, and access discounts and
            waivers — all while receiving real-time support.{" "}
            <b>And the best part? It costs you nothing.</b>
          </p>

          <div className="row">
            <div className="col-md-6 mb-4">
              <div className="techbox">
                <h5>🔍 Discover the Right Program Instantly</h5>
                <p>
                  Your personal <b>Course Navigator</b> puts the world of education at
                  your fingertips.
                </p>
                <p>
                  Browse <b>50+ programs </b>across global universities and EdTech
                  providers.
                </p>
                <p>
                  Filter, shortlist, and compare courses, institutions, and
                  scholarships — fast and with complete accuracy.
                </p>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="techbox">
                <h5>💬 Expert Assistance Made Easy</h5>
                <p>
                 Manage applications without the stress.
                </p>
                <p>Get live-chat support from our team, receive quick answers to queries, and <b>track every application in real time </b> — ensuring a smooth experience for both you and your students.</p>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="techbox">
                <h5>⚡ One Application. Endless Opportunities.e</h5>
                <p>
                  Skip repetitive paperwork.
                </p>
                <p>With one unified application form, you can apply to <b>multiple universities and programs at once</b> , process application fees, and manage everything end-to-end — in a single streamlined workflow.</p>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="techbox">
                <h5>🎯 Smart Eligibility Checker</h5>
                <p>
                  Never waste time on irrelevant programs again.
                </p>
                <p>Our system automatically filters courses based on the student’s profile, showing  <b>only those programs they are eligible for</b> — saving time and improving conversions.</p>
              </div>
            </div>
          </div>



          <div className="tagline_holder">
            <h2>Technology that works for you — faster decisions, smarter enrollments, higher earnings.</h2>
          </div>
        </div>
      </section>
    </>
  );
};

export default Technical;
